import { useQuery } from "@tanstack/react-query";
import { Recipe } from "@core/types";
import { recipeClient } from "@core/clients";

const useGetRecipesQuery = () => {
  return useQuery<Recipe[], any>(["recipes"], async () => {
    return await recipeClient.getRecipes();
  });
};

export default useGetRecipesQuery;
